import "./lib/security-check.js";
import { $ } from "./lib/globals.js";
import { initNavbarRouting } from "./lib/navbar-shared.js";

$(document).ready(() => {
  initNavbarRouting();
});
